'use client';

import { useReportWebVitals } from '@/app/common/monitoring/aws';

export function WebVitalsReporter() {
  useReportWebVitals();
  return null;
}
